import React, { useState, useEffect } from 'react';

// --- Configuration ---
// REPLACE THESE WITH YOUR ACTUAL APP STORE LINKS
const APP_STORE_URLS = {
  IOS: 'https://apps.apple.com/app/id6747519355',
  ANDROID: 'https://play.google.com/store/apps/details?id=com.smart_biology.mobile',
};

// --- Device Detection and Redirection Hook ---
const useAppStoreRedirect = (iosUrl, androidUrl) => {
  const detectAndRedirect = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    let redirectUrl = null;

    // 1. Check for iOS (iPhone, iPad, iPod)
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      redirectUrl = iosUrl;
    } 
    // 2. Check for Android
    else if (/android/i.test(userAgent)) {
      redirectUrl = androidUrl;
    }

    if (redirectUrl) {
      // PERFORM INSTANT REDIRECTION
      console.log(`Detected OS. Instantly redirecting to: ${redirectUrl}`);
      
      // *** IMPORTANT: UNCOMMENT THIS LINE FOR PRODUCTION USE ***
      window.location.replace(redirectUrl); 

    } else {
      console.log("OS not recognized or is Desktop. Displaying link options.");
    }
  };
  
  return detectAndRedirect;
};

// --- Inline SVG Logos for App Stores ---
const GooglePlayIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="currentColor">
        <path d="M2.5 11.235l17.756 8.528L21.5 12 2.5 2.235z"/>
        <path opacity=".7" d="M2.5 11.235l5.24 3.197L21.5 12z" fill="#fff"/>
        <path opacity=".8" d="M2.5 11.235v9.528L10 16.518z"/>
        <path opacity=".8" d="M2.5 11.235v-9.528L10 6.518z"/>
        <path d="M2.5 11.235l17.756-8.528L21.5 12 2.5 21.765z" fill="none" stroke="currentColor"/>
    </svg>
);

const AppleIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 14 16" fill="currentColor">
        <path d="M12.9 8.6c.1.3 0 .7-.1 1-.1.4-.3.7-.6 1-.3.3-.6.5-1.1.6-.5.2-1 .3-1.6.3-.7 0-1.4-.1-2.2-.4-.8-.3-1.4-.7-2-1.3-.6-.6-1-1.4-1.3-2.2-.3-.8-.4-1.6-.4-2.4 0-.4.1-.9.3-1.3.2-.4.4-.8.7-1.1.3-.3.7-.5 1.2-.6.5-.2 1-.2 1.5-.2.5 0 1 .1 1.4.3.4.2.7.5 1 .9.3.4.5.8.6 1.3.1.5.1 1-.1 1.5-.1.4-.4.7-.8.9-.4.1-.7.1-1.1 0-.3-.1-.5-.3-.7-.6-.2-.3-.3-.6-.3-1 .1-.4.2-.7.4-1 .2-.3.4-.5.7-.7.3-.2.6-.3.9-.3.3 0 .5.1.7.3.2.2.3.4.3.7 0 .4-.1.8-.3 1.2-.2.4-.4.8-.7 1.1-.3.3-.6.5-1 .7-.4.2-.8.3-1.2.3-.4 0-.8-.1-1.1-.3-.3-.2-.5-.4-.7-.7-.2-.3-.3-.6-.4-1-.1-.4-.1-.8 0-1.2.1-.4.3-.8.5-1.1.2-.3.5-.6.8-.8.3-.2.6-.3 1-.3.4 0 .8.1 1.1.3.3.2.6.4.8.7.2.3.4.6.5 1 .1.4.1.8 0 1.2-.1.4-.3.8-.5 1.1zm-3.2-6.5c-.3-.2-.6-.3-1-.3-.4 0-.8.1-1.1.4-.3.3-.5.6-.6 1-.1.4-.1.9 0 1.3.1.4.3.8.6 1.1.3.3.7.5 1.1.6.4.1.9.1 1.3 0 .4-.1.8-.3 1.1-.6.3-.3.5-.7.6-1.1.1-.4.1-.9 0-1.3-.1-.4-.3-.8-.6-1.1-.3-.3-.7-.5-1.1-.6-.4-.1-.9-.1-1.3 0z"/>
    </svg>
);


export default function ProductPage() {
    const redirectToStore = useAppStoreRedirect(APP_STORE_URLS.IOS, APP_STORE_URLS.ANDROID);

    // Run the detection and redirect logic immediately upon component load.
    useEffect(() => {
        redirectToStore(); 
    }, [redirectToStore]);

    return (
        <>
            <style>
                {`
                /* CSS equivalent to the Tailwind classes */
                .page-container {
                    min-height: 100vh;
                    background-color: #f9fafb; /* bg-gray-50 */
                    padding: 1rem; /* p-4 */
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                }
                .content-box {
                    width: 100%;
                    max-width: 48rem; /* max-w-xl */
                    background-color: #fff;
                    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04); /* shadow-2xl */
                    border-radius: 0.75rem; /* rounded-xl */
                    padding: 2rem; /* p-8 */
                    border: 1px solid #f3f4f6; /* border border-gray-100 */
                    text-align: center;
                }
                @media (min-width: 768px) {
                    .page-container {
                        padding: 2rem; /* sm:p-8 */
                    }
                    .content-box {
                        padding: 3rem; /* md:p-12 */
                    }
                }
                .icon-circle {
                    margin-left: auto;
                    margin-right: auto;
                    height: 4rem; /* h-16 */
                    width: 4rem; /* w-16 */
                    background-color: #3b82f6; /* bg-blue-500 */
                    border-radius: 9999px; /* rounded-full */
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 1rem; /* mb-4 */
                }
                .icon-svg {
                    height: 2rem; /* h-8 */
                    width: 2rem; /* w-8 */
                    color: #fff; /* text-white */
                }
                .title {
                    font-size: 1.875rem; /* text-3xl */
                    font-weight: 700; /* font-bold */
                    color: #1f2937; /* text-gray-800 */
                }
                .subtitle {
                    font-size: 1rem; /* text-md */
                    color: #4b5563; /* text-gray-600 */
                    margin-top: 0.5rem; /* mt-2 */
                    margin-bottom: 1.5rem; /* mb-6 */
                }
                .fallback-container {
                    margin-top: 2rem; /* mt-8 */
                    padding-top: 1.5rem; /* pt-6 */
                    border-top: 1px solid #e5e7eb; /* border-t border-gray-200 */
                }
                .fallback-title {
                    font-size: 1.25rem; /* text-xl */
                    font-weight: 600; /* font-semibold */
                    color: #374151; /* text-gray-700 */
                    margin-bottom: 1rem; /* mb-4 */
                }
                .button-group {
                    display: flex;
                    flex-direction: column;
                    gap: 1rem; /* space-y-4 */
                }
                .app-button {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    padding: 0.75rem 1.5rem; /* px-6 py-3 */
                    font-weight: 500; /* font-medium */
                    border-radius: 0.5rem; /* rounded-lg */
                    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1); /* shadow-lg */
                    transition: all 150ms ease-in-out;
                    text-decoration: none; /* important for a tags */
                    color: #fff;
                }
                .app-button:hover {
                    transform: scale(1.02);
                }
                .android-button {
                    background-color: #10b981; /* bg-green-600 */
                }
                .android-button:hover {
                    background-color: #059669; /* hover:bg-green-700 */
                }
                .ios-button {
                    background-color: #4f46e5; /* bg-indigo-600 */
                }
                .ios-button:hover {
                    background-color: #4338ca; /* hover:bg-indigo-700 */
                }
                .app-icon {
                    width: 1.25rem; /* w-5 */
                    height: 1.25rem; /* h-5 */
                    margin-right: 0.5rem; /* mr-2 */
                    margin-left: -0.25rem; /* -ml-1 */
                    display: inline;
                }
                .note-text {
                    font-size: 0.75rem; /* text-xs */
                    color: #9ca3af; /* text-gray-400 */
                    margin-top: 1rem; /* mt-4 */
                }
                `}
            </style>
            
            <div className="page-container">
                <div className="content-box">
                    <div className="icon-circle">
                        <svg className="icon-svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"/>
                        </svg>
                    </div>
                    
                    <p className="subtitle">
                        Redirecting you to the correct app store now...
                    </p>

                    {/* Fallback Section (Displayed if the automatic redirect doesn't happen) */}
                    <div className="fallback-container">
                        <h2 className="fallback-title">
                            Trouble Redirecting? Choose Your Store:
                        </h2>
                        <div className="button-group">
                            <a 
                                href={APP_STORE_URLS.ANDROID} 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                className="app-button android-button"
                            >
                                <GooglePlayIcon className="app-icon" />
                                Google Play (Android)
                            </a>
                            <a 
                                href={APP_STORE_URLS.IOS} 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                className="app-button ios-button"
                            >
                                <AppleIcon className="app-icon" />
                                Apple App Store (iOS)
                            </a>
                        </div>
                        <p className="note-text">
                            (Note: The detection logic relies on your browser's User Agent string.)
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}